export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export const fieldClass =
  'mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-900 shadow-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500 disabled:bg-gray-50 disabled:text-gray-500';

export const GENERIC_FIELDS = [
  {
    key: 'masterUrl',
    label: 'Master URL',
    hint: 'Where agents check in. Leave blank to use this discovery master.',
    placeholder: 'https://discovery.example.com',
  },
  {
    key: 'jevEndpoint',
    label: 'Jev endpoint',
    hint: 'Leave blank to ask TypeSafe Jev. Set a URL to use another classifier.',
    placeholder: 'https://jev.example.com/classify',
  },
  {
    key: 'typesafeApiKey',
    label: 'TypeSafe API key',
    secret: true,
    hint: 'Used when the Jev endpoint is blank.',
    placeholder: 'TypeSafe key',
  },
  {
    key: 'typesafeApiUrl',
    label: 'TypeSafe API URL',
    hint: 'Leave blank for https://api.typesafe.ai/v1/systemone.',
    placeholder: 'https://api.typesafe.ai/v1/systemone',
  },
  {
    key: 'typesafeModel',
    label: 'Jev model',
    hint: 'Leave blank for jev-latest.',
    placeholder: 'jev-latest',
  },
  {
    key: 'visionApiKey',
    label: 'Vision API key',
    secret: true,
    hint: 'Lets the observer describe what happens inside each application.',
    placeholder: 'Optional',
  },
];

export const EMPTY_SETTINGS = Object.fromEntries(GENERIC_FIELDS.map((field) => [field.key, '']));
